import MenuHandlerSFC from "./MenuHandler.vue";
export type { IMenuHandlerProps } from "./props";
export const MenuHandler = MenuHandlerSFC;
